var _defs, _use, _use2, _use3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChromeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 3.2173,
    y1: 15,
    x2: 44.7812,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 20.7219,
    y1: 47.6791,
    x2: 41.5039,
    y2: 11.6837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcc934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 26.5981,
    y1: 46.5015,
    x2: 5.8161,
    y2: 10.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e8e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34a853"
  })), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M13.6086 30.0031 3.218 12.006A23.994 23.994 0 0 0 24.0025 48l10.3906-17.9971-.0067-.0068a11.9852 11.9852 0 0 1-20.7778.007Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    fill: "url(#a)",
    transform: "rotate(120 24 24)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    fill: "url(#b)",
    transform: "rotate(-120 24 24)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    fill: "url(#c)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 9.5,
    style: {
      fill: "#1a73e8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeLight);
export default __webpack_public_path__ + "static/media/ChromeLight.e35f9ab0f87b0188ab18384a5063c5c6.svg";
export { ForwardRef as ReactComponent };